import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  CustomButton,
  CustomButtonLight,
  ToggleSwitch,
} from "../UI/CustomButtons";
import styles from "../../_css/SessionCategoryManagement.module.css";

const AddCategoryPopup = ({ show, onHide, handleCreateCategory, data }) => {
  const [titleEn, setTitleEn] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [categoryVisible, setCategoryVisible] = useState(false);

  useEffect(() => {
    if (data) {
      setTitleEn(data.name);
      setTitleAr(data.nameAr);
      setCategoryVisible(data.isVisible);
    }
  }, [data]);

  const handleHidePopup = (e) => {
    e.preventDefault();
    onHide();
  };

  return (
    <Modal centered size="sm" show={show} onHide={onHide}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title>Add Category</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <Form>
          <Form.Group className="mb-3">
            <label className={styles.formLabel}>Category Name (English)</label>
            <Form.Control
              type="text"
              value={titleEn}
              onChange={(e) => setTitleEn(e.target.value)}
              className={styles.input}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <label className={styles.formLabel}>Category Name (Arabic)</label>
            <Form.Control
              type="text"
              value={titleAr}
              style={{ direction: "rtl" }}
              onChange={(e) => setTitleAr(e.target.value)}
              className={styles.input}
            />
          </Form.Group>
          <Form.Group
            className={`${styles.sessionVisiblity} mb-3 d-flex align-items-center justify-content-between`}
          >
            <label className={styles.formLabel}>Category Visibility</label>
            <ToggleSwitch
              value={categoryVisible}
              onChange={setCategoryVisible}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <CustomButtonLight
          onClick={(e) => handleHidePopup(e)}
          text="Cancel"
          width="48%"
        />
        <CustomButton
          onClick={(e) =>
            handleCreateCategory(e, {
              titleEn,
              titleAr,
              categoryVisible,
              id: data?.id || null,
            })
          }
          text={data?.id ? "Update Category" : "Create Category"}
          width="48%"
          icon="refresh"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default AddCategoryPopup;
